module.exports = __webpack_public_path__ + "static/media/Overpass-Bold.d02d0d10.ttf";